<template>
  <div class="dropdownFilter" @mouseenter="$emit('mouseenter')" @mouseleave="$emit('mouseleave')">
    <div class="dropdownFilter__title">
      {{ title }}: <b>{{ filter }}</b>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DropdownFilter',
  props: {
    title: {
      type: String,
      default: '',
    },
    filter: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>

<style lang="scss">
.dropdownFilter {
  position: relative;
  cursor: pointer;

  &__title {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    line-height: 1.5rem;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: $cAddDark02;

    &:after {
      @include icomoon('chevron-down');
      font-size: 6px;
      padding-left: 0.6rem;
      color: $cAddDark02;
    }

    b {
      font-weight: 700;
      color: $cMainDark;
      padding-left: 0.6rem;
    }
  }
}
</style>
<!--/e-commerce/v1/products/search?categoryIds=231400&filters%5B0%5D%5Bkey%5D=itemClass&filters%5B0%5D%5Bvalues%5D%5B0%5D=PRM-->
<!--/e-commerce/v1/products/search?query=&categoryIds=&limit=24&offset=0&orderBy=&filters=%7B%22price%22:%7B%22from%22:0,%22to%22:13900%7D,%22promoGroups%22:[],%22brand%22:[%2262%22]%7D-->
